module.exports = __webpack_public_path__ + "static/img/60-2.26b5498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/60-2.jpg
// module id = Dhm7
// module chunks = 0